import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { INeighborhood } from '@api/types'
import { NeighborhoodFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  deleteNeighborhoodMutation: {
    neighborhood: INeighborhood
  }
}

const mutation = gql`
  mutation DeleteNeighborhoodMutation($input: DeleteNeighborhoodMutationInput!) {
    deleteNeighborhoodMutation(input: $input) {
      neighborhood {
        ...NeighborhoodFragment
      }
    }
  }
  ${NeighborhoodFragment}
`

const mutateHandler = handleFetchResult<IPayload, INeighborhood>({
  handler: (data) => data.deleteNeighborhoodMutation.neighborhood,
  name: 'Neighborhood',
})

export default function deleteNeighborhood(neighborhoodId: string): Promise<INeighborhood> {
  return client.gql
    .mutate({
      mutation,
      variables: { input: { id: neighborhoodId } },
    })
    .then(mutateHandler)
}
